import React, { useContext } from 'react';
import { withStyles } from '@material-ui/core';
import LoginPageStyle from './LoginPageStyle';
import { Typography, TextField } from '@material-ui/core';
import EmailIcon from '@material-ui/icons/Email';
import LockIcon from '@material-ui/icons/Lock';

import logo from 'assets/img/shared/logo.png';
import Button from '@material-ui/core/Button';
import Cookies from 'universal-cookie';
import {Link, useHistory} from 'react-router-dom';

import djangoService from "services/djangoService";
import { UserContext } from 'context/user';
import { handleFormErrors } from "services/errorHandlerService";
import {Form, Formik} from "formik";
import * as Yup from 'yup';
import NavBar from "components/Layout/NavBar/NavBar";

const LoginPage = props => {
  const { classes } = props;
  const history = useHistory();

  const { setUserData } = useContext(UserContext);

  const validationSchema = Yup.object().shape({
    email: Yup.string().required('Email is Required').email('Invalid email'),
    password: Yup.string().required('Password is required')
  });

  const onSubmit = async (values, {setErrors}) => {
    console.log('submit login')

    djangoService.User.authenticate(values.email, values.password).then(response => {
      console.log('login successful', response);
      console.log('set user data', response.data.user)
      setUserData(response.data.user);

      let cookies = new Cookies();
      cookies.set('token', response.data.token, {
        path: '/'
      });

      history.push('/my-account');
    }).catch(error => handleFormErrors(error, setErrors));
  };

  return (
    <div className={classes.root}>
      <NavBar/>

      <div className={classes.formContainer}>
        <div className={classes.logoContainer}>
          <img src={logo} className={classes.logo} alt={'Logo'} />
        </div>
        <Typography variant={'h4'}>User Login</Typography>

        <Formik
          initialValues={{
            email: '',
            password: ''
          }}
          validationSchema={validationSchema}
          onSubmit={onSubmit}
        >
          {({
              values,
              errors,
              handleChange
            }) => (
            <Form className={classes.form}>
              {errors.nonFieldErrors &&
                <Typography variant={'body1'} color={'error'} align={'center'} paragraph>
                  {errors.nonFieldErrors}
                </Typography>
              }

              <TextField
                fullWidth
                name="email"
                classes={{
                  root: classes.textField
                }}
                label="Email Address"
                margin="normal"
                value={values.email}
                error={!!errors.email}
                helperText={errors.email}
                type="email"
                onChange={handleChange}
                InputProps={{
                  startAdornment: <EmailIcon className={classes.startAdornment} />
                }}
              />

              <TextField
                fullWidth
                name="password"
                className={classes.textField}
                label="Password"
                margin="normal"
                value={values.password}
                error={!!errors.password}
                helperText={errors.password}
                type="password"
                onChange={handleChange}
                InputProps={{
                  startAdornment: <LockIcon className={classes.startAdornment} />
                }}
              />

              <div className={classes.extraActions}>
                <Typography variant={'body2'}>
                  <Link to={'/forgot-password'} className={classes.pseudoLink}>Forgot your password?</Link>
                </Typography>
                <Typography variant={'body2'}>
                  Need an account?{' '}
                  <Link to={'/registration'} className={classes.pseudoLink}>
                    Create one.
                  </Link>
                </Typography>
              </div>

              <Button
                type={'submit'}
                color="secondary"
                className={classes.submitButton}
              >
                Submit
              </Button>
            </Form>
          )}
        </Formik>
      </div>
    </div>
  );
};

export default withStyles(LoginPageStyle)(LoginPage);
